/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Pencil = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" }],
    ["path", { d: "m15 5 4 4" }]
  ]
];

export { Pencil as default };
//# sourceMappingURL=pencil.js.map
